import { useState, useCallback } from 'react';

export default function useLocalStorage(key: string): [string | null, (value: string) => void] {
  const [storage, setStorage] = useState(() => {
    const storedData = localStorage.getItem(`DWallet:${key}`);

    return storedData;
  });

  const updateStorage = useCallback((value: string) => {
    localStorage.setItem(`DWallet:${key}`, value);
    setStorage(value);
  }, [key]);

  return [storage, updateStorage];
}

export const storageKey = (key: string) => `DWallet:${key}`;
